import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Divider, IconButton, ImageList, ImageListItem, ImageListItemBar, Paper, Typography } from '@mui/material';

import { ReadFile } from '@paragon/client-tools';
import { Signature } from '@paragon/contract-library';
import { createScrollbarStyling } from '@paragon/themes';

import { createSignatures, removeSignature } from '../../actions/sealsAndSignaturesActions';
import { UserFromSelector } from '../../selectors/users';
import { useAppDispatch } from '../hooks';
import Upload from '../tools/Upload';

interface Props {
  readonly user: UserFromSelector;
}

export function SignatureList({ user }: Props) {
  const dispatch = useAppDispatch();

  const onUpload = async (pFiles: readonly Promise<ReadFile>[]) => {
    const files = await Promise.all(pFiles);
    dispatch(createSignatures(files));
  };

  const onRemove = (signature: Signature) => {
    dispatch(removeSignature(signature));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: '35%', p: 1 }}>
      <Typography variant="h6">Signatures</Typography>
      <Divider sx={{ mb: 4 }} />
      <Paper sx={{ bgcolor: 'backContrast.main' }} elevation={1}>
        <ImageList
          rowHeight={150}
          sx={[{ maxWidth: 500, maxHeight: 450, overflowX: 'hidden', overflowY: 'auto' }, createScrollbarStyling]}
        >
          {user.signatures.map((signature) => (
            <ImageListItem key={signature.id}>
              <Box
                component="img"
                src={signature.image}
                alt="Signature"
                sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
              <ImageListItemBar
                actionIcon={
                  <IconButton
                    onClick={() => {
                      onRemove(signature);
                    }}
                    sx={{ color: '#fff' }}
                  >
                    <DeleteIcon sx={{ color: '#fff' }} />
                  </IconButton>
                }
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Paper>
      <Upload
        onUpload={onUpload}
        buttonSx={{
          mt: 3,
          mb: 1,
          py: 1,
          width: 150,
          color: 'buttonColor.main',
          bgcolor: 'backContrast.main',
          '&:hover': {
            bgcolor: 'primary.dark',
            color: '#fff',
          },
        }}
        id="upload-signature"
        buttonText="Upload"
        accept="image/*"
        multiple={false}
      />
    </Box>
  );
}
